import { render, staticRenderFns } from "./tagSelecter.vue?vue&type=template&id=31c23129&scoped=true"
import script from "./tagSelecter.vue?vue&type=script&lang=js"
export * from "./tagSelecter.vue?vue&type=script&lang=js"
import style0 from "./tagSelecter.vue?vue&type=style&index=0&id=31c23129&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c23129",
  null
  
)

export default component.exports